module.exports = __webpack_public_path__ + "static/media/thumbnail.3f98d6a6.jpg";